import React from "react";
import PropTypes from "prop-types";
import { Button, Form, Icon } from "semantic-ui-react";
import { ArrayField, GroupField, SelectField, TextField } from "react-invenio-forms";
import { LanguagesField } from "@js/invenio_rdm_records";
import _get from "lodash/get";
import { i18next } from "@translations/up/i18next";

import { emptyAdditionalTitle } from "./initialValues";

export const AdditionalTitlesField = ({ fieldPath, options, recordUI }) => {
  return (
    <ArrayField
      addButtonLabel={i18next.t("Add titles")}
      defaultNewValue={emptyAdditionalTitle}
      fieldPath={fieldPath}
      className="additional-titles"
    >
      {({ arrayHelpers, indexPath }) => {
        const fieldPathPrefix = `${fieldPath}.${indexPath}`;
        const langInitialValue = _get(recordUI, `${fieldPathPrefix}.lang`);
        return (
          <GroupField fieldPath={fieldPath} optimized>
            <TextField
              fieldPath={`${fieldPathPrefix}.title`}
              label={i18next.t("Additional title")}
              required
              width={5}
            />
            <SelectField
              fieldPath={`${fieldPathPrefix}.type`}
              label={i18next.t("Type")}
              optimized
              options={options}
              required
              width={5}
            />
            <LanguagesField
              serializeSuggestions={(suggestions) =>
                suggestions.map((item) => ({
                  text: item.title_l10n,
                  value: item.id,
                  fieldPathPrefix: item.id,
                }))
              }
              initialOptions={langInitialValue ? [langInitialValue] : []}
              fieldPath={`${fieldPathPrefix}.lang`}
              label="Language"
              multiple={false}
              placeholder="Select language"
              labelIcon={null}
              clearable
              selectOnBlur={false}
              width={5}
            />
            <Form.Field>
              <Button
                aria-label={i18next.t("Remove field")}
                className="close-btn"
                icon
                onClick={() => arrayHelpers.remove(indexPath)}
              >
                <Icon name="close" />
              </Button>
            </Form.Field>
          </GroupField>
        );
      }}
    </ArrayField>
  );
};

AdditionalTitlesField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  options: PropTypes.array,
  recordUI: PropTypes.object,
};

AdditionalTitlesField.defaultProps = {
  options: [],
  recordUI: undefined,
};
